import { Link } from 'react-router-dom'

function FooterLogo({ className = 'w-8 h-8' }) {
  return (
    <svg
      version="1.2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M25 0.055c-4.227 0 -8.21 1.057 -11.696 2.91l21.79 7.019c8.573 2.752 13.446 11.909 10.741 20.497 -2.263 7.169 -9.03 11.672 -16.191 11.404 -2.295 -0.087 -3.864 -2.374 -3.155 -4.566 0.481 -1.498 1.901 -2.476 3.47 -2.421 4.101 0.134 7.973 -2.476 9.227 -6.609 1.498 -4.897 -1.325 -10.071 -6.199 -11.64L6.68 8.084C2.571 12.524 0.055 18.47 0.055 25c0 7.831 3.612 14.819 9.259 19.393L16.325 22.587c0.591 -1.838 2.563 -2.847 4.401 -2.256s2.847 2.563 2.256 4.401l-7.5 23.328c2.934 1.207 6.144 1.885 9.519 1.885 13.778 0 24.945 -11.167 24.945 -24.945S38.778 0.055 25 0.055"
        fill="#e3ff04"
      />
    </svg>
  )
}

export function Footer() {
  return (
    <footer className="bg-black py-16 border-t border-border-dark relative overflow-hidden">
      {/* Top gradient line */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-linear-to-r from-transparent via-game-primary/30 to-transparent"></div>
      
      <div className="max-w-350 mx-auto px-4 lg:px-20">
        <div className="flex flex-col items-center text-center gap-6">
          <Link to="/" className="inline-flex items-center gap-2.5">
            <FooterLogo className="w-8 h-8" />
            <span className="text-white text-xl font-black leading-tight tracking-[-0.015em]">
              POLYTORIA
            </span>
          </Link>

          <p className="text-slate-500 text-sm leading-relaxed max-w-xl">
            Browser-first gaming with curated experiences, guides, and community highlights.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm text-slate-400 font-bold">
            <Link className="hover:text-white transition-colors" to="/privacy">Privacy Policy</Link>
            <Link className="hover:text-white transition-colors" to="/terms">Terms of Service</Link>
            <Link className="hover:text-white transition-colors" to="/cookies">Cookie Settings</Link>
          </div>

          <div className="w-full h-px bg-border-dark mt-4" />

          <p className="text-xs text-slate-600 font-medium">
            © 2026 Polytoria. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
